class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.summaryAnimated = false;
    this.stepDelayMs = 120;
    this.stepDurationMs = 250;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    // Start with whatever is already in DOM — do not wait for fetch
    this.playCzSummaryAnimation();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.summaryAnimated = false;
    window.clearTimeout(this.summaryAnimTimer);

    const summary = document.querySelector('#cart-notification-cz-summary [data-cz-cart-notif-summary]');
    if (summary) {
      summary.classList.remove('cz-cart-notif-summary--play', 'cz-cart-notif-summary--done');
    }

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !parsedState.sections || !parsedState.sections[section.id]) return;

      const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (html !== null) element.innerHTML = html;
    });

    if (this.header) this.header.reveal();
    this.summaryAnimated = false;
    this.open();
  }

  playCzSummaryAnimation() {
    const summary = document.querySelector('#cart-notification-cz-summary [data-cz-cart-notif-summary]');
    if (!summary || this.summaryAnimated) return;

    this.summaryAnimated = true;
    summary.classList.remove('cz-cart-notif-summary--play', 'cz-cart-notif-summary--done');
    void summary.offsetWidth;
    summary.classList.add('cz-cart-notif-summary--play');

    const steps = summary.querySelectorAll('.cz-cart-notif-summary__row, .cz-cart-notif-summary__hint').length;
    const totalMs = Math.max(0, steps - 1) * this.stepDelayMs + this.stepDurationMs;
    window.clearTimeout(this.summaryAnimTimer);
    this.summaryAnimTimer = window.setTimeout(() => {
      summary.classList.remove('cz-cart-notif-summary--play');
      summary.classList.add('cz-cart-notif-summary--done');
    }, totalMs + 30);
  }

  refreshCzSummary() {
    const element = document.getElementById('cart-notification-cz-summary');
    if (!element) return Promise.resolve();

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(`${root}?sections=cart-notification-cz-summary&_=${Date.now()}`, {
      headers: { 'Cache-Control': 'no-cache' },
    })
      .then((response) => response.json())
      .then((data) => {
        const html = data['cart-notification-cz-summary'];
        if (!html) return;
        const inner = this.getSectionInnerHTML(html);
        if (inner === null) return;

        element.innerHTML = inner;
        const summary = element.querySelector('[data-cz-cart-notif-summary]');
        if (!summary) return;

        // If animation already ran this open — just show updated numbers, no blank gap replay
        if (this.summaryAnimated) {
          window.clearTimeout(this.summaryAnimTimer);
          summary.classList.remove('cz-cart-notif-summary--play');
          summary.classList.add('cz-cart-notif-summary--done');
          return;
        }

        this.playCzSummaryAnimation();
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-notification-cz-summary',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
